import { render } from "./HilfeImWald.vue?vue&type=template&id=f31385d0"
import script from "./HilfeImWald.vue?vue&type=script&lang=js"
export * from "./HilfeImWald.vue?vue&type=script&lang=js"

import "./HilfeImWald.vue?vue&type=style&index=0&id=f31385d0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__